// import Wallet from "../assets/images/icon/purse.png";
// import wallet_in from "../assets/images/icon/wallet-in.png";
// import deposit_fee from "../assets/images/icon/deposit-fee.png";
// import wallet_out from "../assets/images/icon/wallet-out.png";
// import withdraw_fee from "../assets/images/icon/withdraw-fee.png";
// import profit_and_loss_icon from "../assets/images/icon/profit-and-loss.png"; // เปลี่ยนชื่อเพื่อไม่ให้ซ้ำกับตัวแปร
const generateRandomData = (length = 6, max = 10) => {
  return Array.from({ length }, () => Math.floor(Math.random() * max) + 1);
};

// ฟังก์ชันสำหรับสร้างสีสุ่มพร้อมเฉดสีที่แตกต่างกัน
const generateRandomChartColors = () => {
  const randomColor = Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, "0");
  const baseColor = `#${randomColor}`; // สร้างสีที่จางกว่าสำหรับ areaStyle (opacity 0.5)
  const lightColor = `${baseColor}80`; // สร้างสีที่เข้มกว่าสำหรับ itemStyle (opacity 0.9)
  const darkColor = `${baseColor}E6`;
  return {
    areaStyleColor: lightColor,
    itemStyleColor: darkColor,
  };
};

/**
 * ฟังก์ชันช่วยในการจัดรูปแบบ Profit/Loss (Net Income)
 * - หากค่าติดลบ จะแสดงเป็นสีแดง และมีเครื่องหมาย -
 * - หากค่าเป็นบวก จะแสดงเป็นสีเขียว และมีเครื่องหมาย +
 *
 * @param {number} value - ค่า Profit/Loss ที่คำนวณได้
 * @returns {{formattedMoney: string, color: string, icon: string}} - Object ที่มีตัวเลขที่จัดรูปแบบแล้วและโค้ดสี
 */
const formatProfitLoss = (value) => {
  // ตรวจสอบว่าเป็นตัวเลขที่ถูกต้องหรือไม่
  const num = Number(value);
  if (isNaN(num)) {
    return { formattedMoney: 0, color: "gray" };
  }

  if (num < 0) {
    // ขาดทุน: แสดงเครื่องหมายลบ และสีแดง
    return {
      formattedMoney: num,
      color: "red", // หรือโค้ดสีที่คุณใช้ในโปรเจ็กต์
      icon: "",
    };
  } else if (num > 0) {
    // กำไรหรือเท่าทุน: แสดงเครื่องหมายบวก และสีเขียว
    return {
      formattedMoney: num,
      color: "green", // หรือโค้ดสีที่คุณใช้ในโปรเจ็กต์
      icon: "",
    };
  } else {
    return {
      formattedMoney: num,
      color: "dark", // หรือโค้ดสีที่คุณใช้ในโปรเจ็กต์
      icon: undefined,
    };
  }
};

export const ContactCardData = (reportData) => {


  return []
};

export const ContactCardData2 = (reportData) => {
  // -------------------------------------------------------------
  // ส่วนคำนวณข้อมูลรวมจาก reportData
  // -------------------------------------------------------------
  const {
    deposit = 0,
    deposit_fee = 0,
    withdraw = 0,
    withdraw_fee = 0,
    on_hold_deposit = 0,
    on_hold_deposit_fee = 0,
  } = reportData || {};

  // -------------------------------------------------------------
  // ส่วนคำนวณข้อมูลรวม
  // -------------------------------------------------------------

  // รวมค่าธรรมเนียมทั้งหมด
  const totalFees = deposit_fee + withdraw_fee;

  /**
   * รายได้สุทธิ (Net Income) 
   * ปกติคือ ยอดเงินที่รับเข้ามาจริง - ยอดเงินที่ออกไปจริง
   * หรือ (Deposit - Deposit_fee) - (Withdraw + Withdraw_fee) 
   * ผมขอปรับเป็นสูตรมาตรฐาน: (ยอดฝาก - ยอดถอน) - ค่าธรรมเนียมรวม
   */
  const netTotal = deposit - withdraw - totalFees;

  // เรียกใช้ฟังก์ชัน Format (สมมติว่าคุณมีฟังก์ชันนี้อยู่แล้ว)
  // หมายเหตุ: ส่ง netTotal ที่เป็นตัวเลขเข้าไปคำนวณ
  let profitLossFormatted = formatProfitLoss(netTotal);

  return [
    // Deposit
    {
      heading: "Deposit",
      money: deposit || 0,
      perText: "• รวมฝากทั้งหมด",
      icon: undefined,
      color: "green",
      sparklineData: {
        type: "line",
        data: generateRandomData(),
        areaStyle: {
          color: generateRandomChartColors().areaStyleColor,
        },
        itemStyle: {
          color: generateRandomChartColors().itemStyleColor,
        },
        symbolSize: 1,
      },
    },

    // Fee Pay In
    {
      heading: "fee",
      money: deposit_fee || 0,
      perText: "• รวมค่าธรรมเนียมฝาก",
      icon: undefined,
      color: "green",
      sparklineData: {
        type: "line",
        data: generateRandomData(),
        areaStyle: {
          color: generateRandomChartColors().areaStyleColor,
        },
        itemStyle: {
          color: generateRandomChartColors().itemStyleColor,
        },
        symbolSize: 1,
      },
    },

       // on_hold_deposit
       {
        heading: "Deposit on hold",
        money: on_hold_deposit || 0,
        perText: "• Total Transaction on hold",
        icon: undefined,
        color: "warning",
        sparklineData: {
          type: "line",
          data: generateRandomData(),
          areaStyle: {
            color: generateRandomChartColors().areaStyleColor,
          },
          itemStyle: {
            color: generateRandomChartColors().itemStyleColor,
          },
          symbolSize: 1,
        },
      },
  
      // on_hold_deposit Fee
      {
        heading: "fee",
        money: on_hold_deposit_fee || 0,
        perText: "• Total Transaction on hold fee",
        icon: undefined,
        color: "warning",
        sparklineData: {
          type: "line",
          data: generateRandomData(),
          areaStyle: {
            color: generateRandomChartColors().areaStyleColor,
          },
          itemStyle: {
            color: generateRandomChartColors().itemStyleColor,
          },
          symbolSize: 1,
        },
      },

    // Withdrawal
    {
      heading: "Withdrawal",
      money: withdraw || 0,
      perText: "• รวมถอนทั้งหมด",
      icon: undefined,
      color: "red",
      sparklineData: {
        type: "line",
        data: generateRandomData(),
        areaStyle: {
          color: generateRandomChartColors().areaStyleColor,
        },
        itemStyle: {
          color: generateRandomChartColors().itemStyleColor,
        },
        symbolSize: 1,
      },
    },

    // Withdrawal_fee
    {
      heading: "fee",
      money: withdraw_fee || 0,
      perText: "• รวมค่าธรรมเนียมถอน",
      icon: undefined,
      color: "red",
      sparklineData: {
        type: "line",
        data: generateRandomData(),
        areaStyle: {
          color: generateRandomChartColors().areaStyleColor,
        },
        itemStyle: {
          color: generateRandomChartColors().itemStyleColor,
        },
        symbolSize: 1,
      },
    },

    // Total fees
    {
      heading: "Total fees",
      money: totalFees || 0,
      icon: undefined,
      perText: "• ค่าธรรมเนียมฝาก-ถอน",
      color: "info",
      sparklineData: {
        type: "line",
        data: generateRandomData(),
        areaStyle: {
          color: generateRandomChartColors().areaStyleColor,
        },
        itemStyle: {
          color: generateRandomChartColors().itemStyleColor,
        },
        symbolSize: 1,
      },
    },

    // Net income
    {
      heading: "Net income",
      money: profitLossFormatted.formattedMoney,
      icon: profitLossFormatted.icon,
      perText: "• รายได้สุทธิ",
      color: profitLossFormatted.color,
      sparklineData: {
        type: "line",
        data: generateRandomData(),
        areaStyle: {
          color: generateRandomChartColors().areaStyleColor,
        },
        itemStyle: {
          color: generateRandomChartColors().itemStyleColor,
        },
        symbolSize: 1,
      },
    },
  ];
};

export const events = [
  {
    id: 0,
    title: "All Day Event very long title",
    allDay: true,
    start: new Date(2019, 3, 0),
    end: new Date(2019, 3, 1),
  },
  {
    id: 1,
    title: "Long Event",
    start: new Date(2019, 3, 7),
    end: new Date(2019, 3, 10),
  },

  {
    id: 2,
    title: "DTS STARTS",
    start: new Date(2016, 2, 13, 0, 0, 0),
    end: new Date(2016, 2, 20, 0, 0, 0),
  },

  {
    id: 3,
    title: "DTS ENDS",
    start: new Date(2016, 10, 6, 0, 0, 0),
    end: new Date(2016, 10, 13, 0, 0, 0),
  },

  {
    id: 4,
    title: "Some Event",
    start: new Date(2019, 3, 9, 0, 0, 0),
    end: new Date(2019, 3, 10, 0, 0, 0),
  },
  {
    id: 5,
    title: "Conference",
    start: new Date(2019, 3, 11),
    end: new Date(2019, 3, 13),
    desc: "Big conference for important people",
  },
  {
    id: 6,
    title: "Meeting",
    start: new Date(2019, 3, 12, 10, 30, 0, 0),
    end: new Date(2019, 3, 12, 12, 30, 0, 0),
    desc: "Pre-meeting meeting, to prepare for the meeting",
  },
  {
    id: 7,
    title: "Lunch",
    start: new Date(2019, 3, 12, 12, 0, 0, 0),
    end: new Date(2019, 3, 12, 13, 0, 0, 0),
    desc: "Power lunch",
  },
  {
    id: 8,
    title: "Meeting",
    start: new Date(2019, 3, 12, 14, 0, 0, 0),
    end: new Date(2019, 3, 12, 15, 0, 0, 0),
  },
  {
    id: 9,
    title: "Happy Hour",
    start: new Date(2019, 3, 12, 17, 0, 0, 0),
    end: new Date(2019, 3, 12, 17, 30, 0, 0),
    desc: "Most important meal of the day",
  },
  {
    id: 10,
    title: "Dinner",
    start: new Date(2019, 3, 12, 20, 0, 0, 0),
    end: new Date(2019, 3, 12, 21, 0, 0, 0),
  },
  {
    id: 11,
    title: "Birthday Party",
    start: new Date(2019, 3, 13, 7, 0, 0),
    end: new Date(2019, 3, 13, 10, 30, 0),
  },
  {
    id: 12,
    title: "Late Night Event",
    start: new Date(2019, 3, 17, 19, 30, 0),
    end: new Date(2019, 3, 18, 2, 0, 0),
  },
  {
    id: 12.5,
    title: "Late Same Night Event",
    start: new Date(2019, 3, 17, 19, 30, 0),
    end: new Date(2019, 3, 17, 23, 30, 0),
  },
  {
    id: 13,
    title: "Multi-day Event",
    start: new Date(2019, 3, 20, 19, 30, 0),
    end: new Date(2019, 3, 22, 2, 0, 0),
  },
  {
    id: 14,
    title: "Today",
    start: new Date(new Date().setHours(new Date().getHours() - 3)),
    end: new Date(new Date().setHours(new Date().getHours() + 3)),
  },
  {
    id: 15,
    title: "Point in Time Event",
    start: new Date(new Date().setHours(new Date().getHours() - 3)),
    end: new Date(new Date().setHours(new Date().getHours() + 3)),
  },
  {
    id: 16,
    title: "Video Record",
    start: new Date(2019, 3, 14, 15, 30, 0),
    end: new Date(2019, 3, 14, 19, 0, 0),
  },
  {
    id: 17,
    title: "Dutch Song Producing",
    start: new Date(2019, 3, 14, 16, 30, 0),
    end: new Date(2019, 3, 14, 20, 0, 0),
  },
  {
    id: 18,
    title: "Itaewon Halloween Meeting",
    start: new Date(2019, 3, 14, 16, 30, 0),
    end: new Date(2019, 3, 14, 17, 30, 0),
  },
  {
    id: 19,
    title: "Online Coding Test",
    start: new Date(2019, 3, 14, 17, 30, 0),
    end: new Date(2019, 3, 14, 20, 30, 0),
  },
  {
    id: 20,
    title: "An overlapped Event",
    start: new Date(2019, 3, 14, 17, 0, 0),
    end: new Date(2019, 3, 14, 18, 30, 0),
  },
  {
    id: 21,
    title: "Phone Interview",
    start: new Date(2019, 3, 14, 17, 0, 0),
    end: new Date(2019, 3, 14, 18, 30, 0),
  },
  {
    id: 22,
    title: "Cooking Class",
    start: new Date(2019, 3, 14, 17, 30, 0),
    end: new Date(2019, 3, 14, 19, 0, 0),
  },
  {
    id: 23,
    title: "Go to the gym",
    start: new Date(2019, 3, 14, 18, 30, 0),
    end: new Date(2019, 3, 14, 20, 0, 0),
  },
];
